import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import CareerLanding from "../views/CareerLanding";

export default function Career() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    // run initializations here
  }

  function getView() {
  if  (
    !appContext.navSubItem &&
    !appContext.navExtraItem && 
    !appContext.navMoreItem
  ) {
      return <CareerLanding />;
    }

    return <CareerLanding />;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
